import { cn } from "@/utils/cn";
import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "danger";
}

export const Button = ({
  children,
  className = "",
  variant = "default",
  disabled,
  ...props
}: ButtonProps) => {
  const baseStyles =
    "inline-flex justify-center rounded-md border px-2 py-1.5 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed h-8";

  const variantStyles = {
    default: "border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
    danger: "border-red-300 bg-white text-red-700 hover:bg-red-50",
  };

  return (
    <button
      className={cn(baseStyles, variantStyles[variant], className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
